import { FC } from "react";
import { personas } from "./constant";
import { Link } from "react-router-dom";

export const PersonasSection: FC = () => {
  return (
    <section className="bg-white md:bg-pbg text-blueShades-4">
      <div className="py-16 md:py-24 px-4 md:px-16">
        <div className="flex flex-col justify-center items-center gap-10 referral-container">
          <div className="flex flex-col gap-6 text-center">
            <p className="text-blueShades-4 text-5xl font-SatoshiBold md:w-[550px] m-auto">
              Built For
            </p>
            <p className="text-ashShade-16 text-xl md:text-lg font-SatoshiMedium md:w-[660px] m-auto">
              anyone deploying capital in real estate and construction
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            {personas.map((persona, index) => (
              <div
                key={index}
                className={` bg-white rounded-xl hover:shadow-[0px_8px_24px_0px_#0000001F] hover:cursor-pointer border border-[#E5EAF0] p-4 md:p-6 flex flex-col gap-12 items-start transition-all duration-300 hover:md:scale-105 hover:md:z-10`}
              >
                <img src={persona.icon} alt="" className="w-10 h-10" />
                <div className="flex flex-col gap-2">
                  <p className="text-2xl text-blueShades-4 font-SatoshiBold">
                    {persona.title}
                  </p>
                  <p className="text-ashShade-16 text-base font-SatoshiMedium">
                    {persona.description}
                  </p>
                  <Link
                    to={persona.link}
                    className="text-[#FF8A34] hover:underline text-sm font-SatoshiMedium"
                  >
                    Learn more
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
